var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-policy-detail',{staticClass:"pt-policy-detail__withData",attrs:{"policyDetail":_vm.policyDetail,"type":_vm.type,"typeName":_vm.typeName,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }